module.exports = __webpack_public_path__ + "img/import-zip.05409c4a.png";